"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OlapicCategory = require("./OlapicCategory");
Object.keys(_OlapicCategory).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicCategory[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicCategory[key];
    }
  });
});
var _OlapicConfiguration = require("./OlapicConfiguration");
Object.keys(_OlapicConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicConfiguration[key];
    }
  });
});
var _OlapicInfo = require("./OlapicInfo");
Object.keys(_OlapicInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicInfo[key];
    }
  });
});
var _OlapicMedia = require("./OlapicMedia");
Object.keys(_OlapicMedia).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicMedia[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicMedia[key];
    }
  });
});
var _OlapicReport = require("./OlapicReport");
Object.keys(_OlapicReport).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicReport[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicReport[key];
    }
  });
});
var _OlapicResponse = require("./OlapicResponse");
Object.keys(_OlapicResponse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponse[key];
    }
  });
});
var _OlapicResponseCategory = require("./OlapicResponseCategory");
Object.keys(_OlapicResponseCategory).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponseCategory[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponseCategory[key];
    }
  });
});
var _OlapicResponseCategoryItem = require("./OlapicResponseCategoryItem");
Object.keys(_OlapicResponseCategoryItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponseCategoryItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponseCategoryItem[key];
    }
  });
});
var _OlapicResponseMedia = require("./OlapicResponseMedia");
Object.keys(_OlapicResponseMedia).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponseMedia[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponseMedia[key];
    }
  });
});
var _OlapicResponseMediaById = require("./OlapicResponseMediaById");
Object.keys(_OlapicResponseMediaById).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponseMediaById[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponseMediaById[key];
    }
  });
});
var _OlapicResponseMediaItem = require("./OlapicResponseMediaItem");
Object.keys(_OlapicResponseMediaItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponseMediaItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponseMediaItem[key];
    }
  });
});
var _OlapicResponseMediaStreams = require("./OlapicResponseMediaStreams");
Object.keys(_OlapicResponseMediaStreams).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponseMediaStreams[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponseMediaStreams[key];
    }
  });
});
var _OlapicResponseStream = require("./OlapicResponseStream");
Object.keys(_OlapicResponseStream).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponseStream[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponseStream[key];
    }
  });
});
var _OlapicResponseStreamItem = require("./OlapicResponseStreamItem");
Object.keys(_OlapicResponseStreamItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicResponseStreamItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicResponseStreamItem[key];
    }
  });
});
var _OlapicStream = require("./OlapicStream");
Object.keys(_OlapicStream).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicStream[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicStream[key];
    }
  });
});
var _enums = require("./enums");
Object.keys(_enums).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _enums[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _enums[key];
    }
  });
});
